import { Form } from "antd";
import { useEffect } from "react";
import { FormModal } from "@/shared/components/FormModal";
import { useCreateStaffWorkday, useUpdateStaffWorkday } from "../hooks/useStaffWorkday";
import { useStaffWorkdayStore } from "../store/staff-workday.store";
import { StaffWorkdayForm } from "./StaffWorkdayForm";

interface FormValues {
	staffId: string;
	dayNumber: number;
	start: string;
	end: string;
	isWorkday: boolean;
}

export function StaffWorkdayFormModal() {
	const [form] = Form.useForm<FormValues>();
	const { modalOpen, editingItem, closeModal } = useStaffWorkdayStore();

	const { mutate: create, isPending: isCreating } = useCreateStaffWorkday();
	const { mutate: update, isPending: isUpdating } = useUpdateStaffWorkday();

	const close = () => {
		form.resetFields();
		closeModal();
	};

	useEffect(() => {
		if (modalOpen) {
			if (editingItem) {
				form.setFieldsValue({
					staffId: editingItem.staffId,
					dayNumber: editingItem.dayNumber,
					start: editingItem.start,
					end: editingItem.end,
					isWorkday: editingItem.isWorkday,
				});
			} else {
				form.resetFields();
				form.setFieldsValue({ isWorkday: true });
			}
		}
	}, [modalOpen, editingItem, form]);

	const onFinish = (values: FormValues) => {
		if (editingItem) {
			update(
				{
					id: editingItem.id,
					data: {
						staffId: values.staffId,
						dayNumber: values.dayNumber,
						start: values.start,
						end: values.end,
						isWorkday: values.isWorkday,
					},
				},
				{ onSuccess: close }
			);
		} else {
			create(
				{
					staffId: values.staffId,
					dayNumber: values.dayNumber,
					start: values.start,
					end: values.end,
					isWorkday: values.isWorkday ?? true,
				},
				{ onSuccess: close }
			);
		}
	};

	return (
		<FormModal
			title="Yangi ish kuni"
			editTitle="Ish kunini tahrirlash"
			editing={!!editingItem}
			open={modalOpen}
			onCancel={close}
			onOk={form.submit}
			confirmLoading={isCreating || isUpdating}
			width={520}
		>
			<Form form={form} layout="vertical" requiredMark={false} onFinish={onFinish}>
				<StaffWorkdayForm />
			</Form>
		</FormModal>
	);
}
